export default class Editor {

    constructor(callback) {
        this.callback = callback;
        this.handleData = this.handleData.bind(this);
    }

    articleRequest(reference, pathname) {
        const array = pathname.split("/");
        const length = array.length;
        const key = (length <= 3) ? null : array[length - 1];
        this.key = key;
        if (reference && key) {
            reference.child(key).orderByChild('position').once('value', this.handleData);
        }
    }

    handleData(snapshot) {
        let article = {
            id: this.key,
            title: "",
            photo: "",
            sections: {}
        };
        if (snapshot.exists()) {
            const {title, photo} = snapshot.val();
            const sections = {};
            const id = snapshot.key;
            snapshot.forEach(function (childSnapshot) {
                const key = childSnapshot.key;
                if (key !== 'title' && key !== 'photo' && key !== 'key') {
                    sections[key] = childSnapshot.val();
                }
            });
            article = {
                id,
                title,
                photo,
                sections
            };

        }

        this.callback(article);
    }

}


// WEBPACK FOOTER //
// ./src/admin/components/editor/presenters/Editor.js